import { InferenceEventImage } from 'store/socket/listener'
import { InferenceImage } from 'type/Inference'

export class InferenceImageStore {
  readonly id: number
  readonly src: string

  static fromJson(json: InferenceImage): InferenceImageStore {
    const id = json.image_id
    const src = json.image_url
    return new InferenceImageStore(id, src)
  }

  static fromEvent(event: InferenceEventImage): InferenceImageStore | undefined {
    if (event.isVideo) return undefined
    const id = event.int_id
    const src = event.url
    return new InferenceImageStore(id, src)
  }

  constructor(id: number, src: string) {
    this.id = id
    this.src = src
  }
}
